import { render } from "./SideBarFooter.vue?vue&type=template&id=c6f6c8d0&scoped=true"
import script from "./SideBarFooter.vue?vue&type=script&lang=js"
export * from "./SideBarFooter.vue?vue&type=script&lang=js"

import "./SideBarFooter.vue?vue&type=style&index=0&id=c6f6c8d0&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f6c8d0"]])

export default __exports__